import * as React from 'react';
import { Chip, Stack, SxProps } from '@mui/material';

interface ChipProps {
  label: string;
  variant: 'filled' | 'outlined' | undefined;
  color:
    | 'error'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'default'
    | undefined;
  size: 'small' | 'medium' | undefined;
  sx?: SxProps;
  testId?: string;
}
export function Chips({ label, variant, color, size, sx, testId }: ChipProps) {
  return (
    <Stack direction="row" spacing={1}>
      <Chip
        label={label}
        variant={variant}
        color={color}
        size={size}
        sx={sx}
        data-testid={testId}
      />
    </Stack>
  );
}
